import { Link, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";



const SideMenu = ({page, children}) => {

    return (
        <div className="sm_menu_wrapper">
            <Link className={`menu_item ${ page == 'home' ? 'active' : '' }`} to={'/'}>მთავარი</Link>
            <Link className={`menu_item ${ page == 'catalog' ? 'active' : '' }`} to={'/catalog'}>კატალოგი</Link>
            <Link className={`menu_item ${ page == 'about' ? 'active' : '' }`} to={'/about'}>ჩვენს შესახებ</Link>
            <a className={`menu_item tel_item`}href="https://www.facebook.com/@SkyHookGeorgia" target='_blank'>
                <img src="/images/fb.png" alt="" /> <p>Facebook</p>
            </a>
            <a className={`menu_item tel_item`} href="https://www.instagram.com/skyhookgeorgia" target='_blank'>
                <img src="/images/instagram.png" alt="" /> <p>Instagram</p>
            </a>
            <Link className={`menu_item tel_item`} to={'tel:+995598666022'}>
                <img src="/images/tel.png" alt="" /> <p>598 666 022</p>
            </Link>
        </div>
    )
}
  
export default SideMenu